<template>
	<div class="mision">
		<v-container  
				class="overflow-y-auto"
		>
			<v-layout row>
				<v-flex md9 xs12 class="pt-5 pa-4">
					<v-card
						class="mx-auto"
						color=""
						max-width="800"
					>
						<v-card-title>
						<v-icon
							large
							left
						>
							mdi-bank
						</v-icon>
						<h1>MISIÓN</h1>
						</v-card-title>

						<v-card-text class="headline font-weight-bold text-justify">
							"Administrar Justicia a través de sus órganos jurisdiccionales, con arreglo a la Constitución y a las leyes, garantizando la seguridad jurídica y la tutela jurisdiccional, para contribuir al estado de derecho, al mantenimiento de la paz social y al desarrollo nacional". Para el cabal cumplimiento de esta misión es necesario dotar al Poder Judicial de los siguientes elementos: Magistrados respetados, probos, capaces, éticos y justos y, además, actualizados en su calificación jurídica. Crear nuevos sistemas de gestión y modernización para contar con despachos judiciales modernos, con infraestructura adecuada y sistemas de información actualizados. Proporcionar a los magistrados el personal de apoyo jurisdiccional y administrativo capacitado y con vocación de servicio.
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex md9 xs12 class="pt-5 pa-4">
					<v-card
						class="mx-auto"
						color=""
						max-width="800"
					>
						<v-card-title>
						<v-icon
							large
							left
						>
							mdi-bank
						</v-icon>
						<h1>VISIÓN</h1>
						</v-card-title>

						<v-card-text class="headline font-weight-bold text-justify">
						Institución autónoma con vocación de servicio; que enfrente los desafíos del futuro con magistrados comprometidos con el proceso de cambio, transformación y modernidad; que se traduzca en seguridad jurídica e inspire plena confianza en la ciudadanía, contando para ello con un adecuado soporte administrativo y tecnológico.
						</v-card-text>
					</v-card>
						
				</v-flex>
				<v-flex md3 xs12>
					<Servicios />
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
  const Servicios = () => import('@/components/Servicios.vue')
	export default {
		components: {
			Servicios
		},
	}

</script>
